import { render } from "./AccountingMonthGeneral.vue?vue&type=template&id=dfd52ffe"
import script from "./AccountingMonthGeneral.vue?vue&type=script&lang=js"
export * from "./AccountingMonthGeneral.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__